export default __webpack_public_path__ + "static/media/bookdoc-premium-plus-btn.bfc98cca.png";